"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.palApollo = exports.MinigolfColors = void 0;
exports.MinigolfColors = [
    {
        name: 'Blue',
        tint: 0x4f8fba,
    },
    {
        name: 'Green',
        tint: 0x75a743, // diveColors.green,
    },
    {
        name: 'Brown',
        tint: 0xc09473,
    },
    {
        name: 'Orange',
        tint: 0xbe772b,
    },
    {
        name: 'Red',
        tint: 0xa53030, //diveColors.peach,
    },
    {
        name: 'Pink',
        tint: 0xa23e8c, //.red,
    },
    {
        name: 'Grey',
        tint: 0x394a50,
    },
];
var blues = [0x172038, 0x253a5e, 0x3c5e8b, 0x4f8fba, 0x73bed3, 0xa4dddb];
var greens = [0x19332d, 0x25562e, 0x468232, 0x75a743, 0xa8ca58, 0xd0da91];
var browns1 = [0x4d2b32, 0x7a4841, 0xad7757, 0xc09473, 0xd7b594, 0xe7d5b3];
var browns2 = [0x341c27, 0x602c2c, 0x884b2b, 0xbe772b, 0xde9e41, 0xe8c170];
var reds = [0x241527, 0x411d31, 0x752438, 0xa53030, 0xcf573c, 0xda863e];
var pinks = [0x1e1d39, 0x402751, 0x7a367b, 0xa23e8c, 0xc65197, 0xdf84a5];
var grays = [
    0x090a14, 0x10141f, 0x151d28, 0x202e37, 0x394a50, 0x577277, 0x819796,
    0xa8b5b2, 0xc7cfcc, 0xebede9,
];
exports.palApollo = {
    blues: blues,
    greens: greens,
    browns1: browns1,
    browns2: browns2,
    reds: reds,
    pinks: pinks,
    grays: grays,
    blue100: blues[0],
    blue200: blues[1],
    blue300: blues[2],
    blue400: blues[3],
    blue500: blues[4],
    blue600: blues[5],
    green100: greens[0],
    green200: greens[1],
    green300: greens[2],
    green400: greens[3],
    green500: greens[4],
    green600: greens[5],
    brown100: browns1[0],
    brown200: browns1[1],
    brown300: browns1[2],
    brown400: browns1[3],
    brown500: browns1[4],
    brown600: browns1[5],
    brown2100: browns2[0],
    brown2200: browns2[1],
    brown2300: browns2[2],
    brown2400: browns2[3],
    brown2500: browns2[4],
    brown2600: browns2[5],
    red100: reds[0],
    red200: reds[1],
    red300: reds[2],
    red400: reds[3],
    red500: reds[4],
    red600: reds[5],
    pink100: pinks[0],
    pink200: pinks[1],
    pink300: pinks[2],
    pink400: pinks[3],
    pink500: pinks[4],
    pink600: pinks[5],
    gray100: grays[0],
    gray200: grays[1],
    gray300: grays[2],
    gray400: grays[3],
    gray500: grays[4],
    gray600: grays[5],
    gray700: grays[6],
    gray800: grays[7],
    gray900: grays[8],
    gray1000: grays[9],
};
